module.exports = __webpack_public_path__ + "img/187.2ea53da9.jpg";